import { render, staticRenderFns } from "./ViewTransacoesAvulsaModal.vue?vue&type=template&id=1e912e32&"
import script from "./ViewTransacoesAvulsaModal.vue?vue&type=script&lang=js&"
export * from "./ViewTransacoesAvulsaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports